import handler from "api/handler";

const prefix = "/api/public/requirement";

const requirementMethods = {
  create: (data, config = {}) =>handler({ method: "post", url: `${prefix}/create`, data, ...config }),
  getAll: (params, config = {}) =>handler({ method: "get", url: `${prefix}/all`, params, ...config }),
  getById: (id, config = {}) =>handler({ method: "get", url: `${prefix}/${id}`, ...config }),
  update: (id, data, config = {}) =>handler({ method: "put", url: `${prefix}/update/${id}`, data, ...config }),
  delete: (id, config = {}) =>handler({ method: "delete", url: `${prefix}/delete/${id}`, ...config }),
};

export default requirementMethods;
